// Video Generation Page (Coming Soon)
import { useState } from 'react';
import './VideoGeneration.css';

const VideoGeneration = () => {
  const [email, setEmail] = useState('');
  const [notified, setNotified] = useState(false);

  const handleNotify = (e) => {
    e.preventDefault();
    // TODO: Implement email notification
    setNotified(true);
    setEmail('');
    setTimeout(() => setNotified(false), 5000);
  };

  return (
    <div className="video-generation-container">
      <div className="video-generation-card">
        <div className="video-generation-header">
          <h1>🎥 AI Video Generator</h1>
          <p>Create amazing videos from text prompts</p>
          <span className="coming-soon-badge">Coming Soon</span>
        </div>

        <div className="feature-preview">
          <h2>Upcoming Features</h2>
          <ul className="feature-list">
            <li>Generate videos from text descriptions</li>
            <li>Multiple video styles and formats</li>
            <li>Customizable duration and quality</li>
            <li>Add music and sound effects</li>
            <li>Export in various formats (MP4, WebM, etc.)</li>
          </ul>
        </div>

        <div className="notify-form">
          <h3>Get notified when video generation launches</h3>
          <form onSubmit={handleNotify}>
            <div className="notify-input-group">
              <input
                type="email"
                className="notify-input"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button type="submit" className="notify-btn">
                Notify Me
              </button>
            </div>
            {notified && (
              <div className="success-message">
                Thanks! We'll notify you when video generation is available.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default VideoGeneration;
